import React from 'react';
import Page from 'components/Page';
import SettingsTabs from './SettingsTabs';
import EventEdit from './EventEdit';
import EventNotifications from './EventNotifications';

function EventSettings({ location, match }) {
  const eventId = Number(match.params.id);
  const eventSlug = match.params.slug;
  const activeTab = location.pathname.split('/')[4];

  return (
    <Page>
      <SettingsTabs activeKey={activeTab} eventId={eventId} eventSlug={eventSlug} />

      <div hidden={activeTab !== 'edit'}>
        <EventEdit eventId={eventId} eventSlug={eventSlug} />
      </div>

      <div hidden={activeTab !== 'notifications'}>
        <EventNotifications eventId={eventId} />
      </div>
    </Page>
  );
}

export default EventSettings;
